<template>
    <div>
        <v-card class="client-transactions-summary" outlined>
            <v-card-title class="page-heading primary">
                <v-row align="center">
                    <v-col cols="12" sm="9">
                        {{ $tc('client_transactions.heading', 2) }}
                    </v-col>
                </v-row>
            </v-card-title>

            <v-card-text>
                <v-text-field
                    v-model="filter.search"
                    :label="$t('general.search')"
                    append-icon="far fa-search"
                    clearable
                    clear-icon="fal fa-times"
                    single-line
                    hide-details
                    class="search"
                />

                <v-data-table
                    class="items-table operations striped"
                    :headers="headers"
                    :items="items"
                    :options.sync="pagination"
                    :footer-props="{ 'items-per-page-options': [20, 50, 100, 200] }"
                    :items-per-page.sync="pagination.itemsPerPage"
                    :server-items-length="itemsTotal"
                    :loading="loading"
                    :mobile-breakpoint="0"
                    dense
                >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.client.name }}</td>
                            <td align="right">{{ item.debt }}</td>
                            <td align="right">{{ item.credit }}</td>
                            <td align="right">{{ item.balance }}</td>
                            <td align="center" class="w35 maxw60">
                                <v-menu bottom transition="slide-y-transition">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon>
                                            <v-icon>far fa-ellipsis-h</v-icon>
                                        </v-btn>
                                    </template>

                                    <v-list>
                                        <v-list-item
                                            key="print"
                                            :disabled="false"
                                            @click="goToClientTransactions(item)"
                                        >
                                            <v-list-item-action class="mr-4 flex justify-content-center">
                                                <v-icon :disabled="false">fal fa-eye</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-title>{{ $t('general.view') }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import ApiService from '@/services/ApiService';
import _ from 'lodash';

export default {
    data() {
        return {
            items: [],
            itemsTotal: 0,
            loading: false,

            filter: {
                search: null,
            },

            headers: [
                { text: this.$tc('general.client', 1), value: 'name' },
                { text: this.$t('client_transactions.debt'), value: 'debt', align: 'right' },
                { text: this.$t('client_transactions.credit'), value: 'credit', align: 'right' },
                { text: this.$t('client_transactions.balance'), value: 'balance', align: 'right' },
                { text: '', sortable: false }
            ],

            pagination: {
                sortBy: ['balance'],
                itemsPerPage: 100,
                page: 1,
                sortDesc: [true],
            },
        };
    },

    watch: {
        pagination: {
            handler() {
                this.getItems();
            },
            deep: true
        },

        filter: {
            handler() {
                this.getItemsDebounce();
            },
            deep: true
        },
    },

    methods: {
        getItems() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;
            const sortField = sortBy[0] ? sortBy[0] : 'date';
            const sortOrder = sortDesc[0] ? 'descending' : 'ascending';

            let url = `/admin/client-transactions/summary?page=${page}&itemsPerPage=${itemsPerPage}&sortField=${sortField}&sortOrder=${sortOrder}`;

            if (this.filter) {
                Object.keys(this.filter).forEach(key => {
                    if(this.filter[key]) {
                        url += `&${key}=${this.filter[key]}`;
                    }
                })
            }

            this.loading = true;

            ApiService.get(url).then(response => {
                this.loading = false;
                this.items = response.data.data;
                this.itemsTotal = response.data.total;
            });
        },

        getItemsDebounce: _.debounce(function() {
            this.getItems();
        }, 500),

        goToClientTransactions(item) {
            this.$router.push({ name: 'adminClientTransactions', params: { client_id: item.client.id } }).catch(err => {});
        }
    }
};
</script>

<style lang="scss" scoped>
.client-transactions-summary {
    .page-heading {
        padding: 12px 16px;
        color: white;
        font-size: 16px;
        word-break: break-word;
    }

    ::v-deep .items-table {
        margin-top: 28px;

        th {
            font-size: 11px;
            padding: 0 4px;
            max-width: 80px;

            span {
                white-space: break-spaces;
            }
        }

        td {
            font-size: 13px;
            padding: 0 4px;
        }

        .separator {
            border-left: 1px solid rgba(0, 0, 0, 0.5);
            padding-left: 12px;
        }

        tfoot {
            font-weight: 500;
            background: #f3f4fb;
        }
    }
}
</style>
